<template>
  <div>
    <section class="faq-contact">
      <b-row class="pt-75 text-center">
        <!-- YouTube -->
        <b-col sm="6" class="mb-2">
          <b-card class="faq-contact-card hover-card py-3">
            <b-link
                href="https://www.youtube.com/@taskfino"
                target="_blank"
                rel="noopener"
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
              <div class="icon-circle youtube-gradient mb-2">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="white"
                >
                  <path d="M23.498 6.186a2.978 2.978 0 0 0-2.099-2.104C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.399.582a2.978 2.978 0 0 0-2.099 2.104C0 8.092 0 12 0 12s0 3.908.502 5.814a2.978 2.978 0 0 0 2.099 2.104C4.5 20.5 12 20.5 12 20.5s7.5 0 9.399-.582a2.978 2.978 0 0 0 2.099-2.104C24 15.908 24 12 24 12s0-3.908-.502-5.814zM9.75 15.568V8.432L15.568 12 9.75 15.568z"/>
                </svg>
              </div>
              <h5 class="font-weight-bold text-dark">Watch Tutorials</h5>
              <small class="text-muted">Learn from our YouTube channel</small>
            </b-link>
          </b-card>
        </b-col>

        <!-- Documentation -->
        <b-col sm="6" class="mb-2">
          <b-card class="faq-contact-card hover-card py-3">
            <b-link
                href="https://docs.taskfino.com/"
                target="_blank"
                rel="noopener"
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
              <div class="icon-circle doc-gradient mb-2">
                <feather-icon icon="BookOpenIcon" size="26" class="text-white" />
              </div>
              <h5 class="font-weight-bold text-dark">Read Documentation</h5>
              <small class="text-muted">Step-by-step guides & API reference</small>
            </b-link>
          </b-card>
        </b-col>
      </b-row>
    </section>

    <!-- faq search section -->
    <section id="faq-search-filter">
      <b-card
        no-body
        class="faq-search"
        :style="{ backgroundImage: `url(${bannerImage})` }"
      >
        <b-card-body class="text-center" style="padding: 4rem !important;">
          <h2 class="text-primary">
            Let's answer some questions
          </h2>
          <b-card-text class="mb-2">
            or choose a category to quickly find the help you need
          </b-card-text>

          <!-- form -->
          <b-form class="faq-search-input">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="searchbar"
                v-model="faqSearchQuery"
                placeholder="Search faq..."
              />
            </b-input-group>
          </b-form>
          <!-- form -->
        </b-card-body>
      </b-card>
    </section>
    <!--/ faq search section -->

    <!-- frequently asked questions tabs pills -->
    <section id="faq-tabs">
      <b-tabs
        vertical
        content-class="col-12 col-md-8 col-lg-9"
        pills
        nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
        nav-class="nav-left"
      >

        <!-- payment tab -->
        <b-tab
          v-for="(categoryObj, categoryName, index) in faqData"
          :key="categoryName"
          :active="!index"
        >

          <!-- title -->
          <template #title>
            <feather-icon
              :icon="categoryObj.icon"
              size="18"
              class="mr-1"
            />
            <span class="font-weight-bold">{{ categoryObj.title }}</span>
          </template>

          <faq-question-answer :options="categoryObj" />
        </b-tab>
        <!--/ payment tab -->

        <!-- sitting lady image -->
        <template #tabs-end>
          <b-img
            fluid
            :src="require('@/assets/images/illustration/faq-illustrations.svg')"
            class="d-none d-md-block mt-auto"
          />
        </template>
        <!--/ sitting lady image -->
      </b-tabs>
    </section>
    <!--/ frequently asked questions tabs pills -->

    <!-- contact us -->
    <section class="faq-contact" v-if="user?.roles.data[0]?.admin === 1">
      <b-row class="mt-5 pt-75 text-center">
        <b-col cols="12">
          <h2>You still have a question?</h2>
          <b-card-text class="mb-3">
            If you cannot find a question in our FAQ, you can always contact us. We will answer to you shortly!
          </b-card-text>
        </b-col>
        <b-col sm="12">
          <b-card class="shadow-none py-1 faq-contact-card">

            <XdeskView
                :details="xdeskUser"
                :is-admin="false"
                secret-key="secret-6m245chapl706m5ijqpk4p612"
                :set-loader="setLoading"
                :is-loading="isLoading"
            >
              <!-- Row for centering -->
              <b-row class="justify-content-center">
                <b-col cols="12" sm="6" md="4" lg="3">
                  <button class="btn btn-success w-100 d-flex align-items-center justify-content-center">
                    <template v-if="isLoading">
                      <span class="spinner-border spinner-border-sm"></span>
                    </template>
                    <template v-else>
                      <feather-icon icon="HelpCircleIcon" size="18" class="mr-1" />
                      Support
                    </template>
                  </button>
                </b-col>
              </b-row>
            </XdeskView>

            <br />
            <span class="text-body">We are always happy to help!</span>
          </b-card>
        </b-col>
      </b-row>
    </section>
    <!--/ contact us -->
  </div>
</template>

<script>
import {
  BCard, BCardBody, BForm, BInputGroup, BFormInput, BCardText, BInputGroupPrepend, BTabs, BTab, BImg, BRow, BCol, BAvatar,
  BLink,
} from 'bootstrap-vue'
import FaqQuestionAnswer from './FaqQuestionAnswer.vue'
import bannerImage from '@/assets/images/banner/banner.png';
import XdeskView from '../xdesk/XdeskView.vue';
import { mapGetters } from "vuex";

export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BAvatar,
    BCardBody,
    BInputGroup,
    BFormInput,
    BCardText,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BImg,
    FaqQuestionAnswer,
    XdeskView,
    BLink,
  },
  data() {
    return {
      faqSearchQuery: '',
      data: {
        // General & Technical
        general: {
          icon: 'HelpCircleIcon',
          title: 'General & Technical',
          subtitle: 'Setup, Login, and Security questions.',
          qandA: [
            {
              question: 'What is TaskFino?',
              ans: 'TaskFino is an all-in-one office management software designed to streamline your business operations. It integrates essential functions like HRMS, Payroll, CRM, Accounting, and more into a single, unified platform.'
            },
            {
              question: 'What are the system requirements to use TaskFino?',
              ans: 'TaskFino is a web-based application requiring only a stable internet connection and a modern web browser (like Google Chrome, Firefox, or Safari). It works on any desktop, laptop, tablet, or mobile device.'
            },
            {
              question: 'Is there a mobile or desktop app?',
              ans: 'Yes. For the best experience, you can install the TaskFino app on both your desktop and mobile devices. The installation option is available on the login page at `https://app.taskfino.com` before you log in.'
            },
            {
              question: 'What am I seeing on the main dashboard when I log in?',
              ans: 'The dashboard provides a complete operational overview. It includes summaries of lead statuses, asset assignments, today\'s employee attendance, pending leave requests, upcoming project milestones, task progress, and a financial snapshot of income vs. expense.'
            },
            {
              question: 'How are user permissions and data access managed?',
              ans: 'TaskFino has a comprehensive Role & Permission Management system. You can create custom roles (e.g., Admin, Manager, HR) and assign granular permissions, controlling exactly who can view, create, edit, or delete information within each module to ensure data security.'
            },
            {
              question: 'What should I do if I forget my password?',
              ans: 'On the login page, you should find a "Forgot Password" or "Reset Password" link. You will typically need to enter your registered email address to receive instructions on how to create a new password.'
            }
          ]
        },
        hrms: {
          icon: 'UsersIcon',
          title: 'HRMS',
          subtitle: 'Employee management, attendance, and leave-related questions.',
          qandA: [
            {
              question: 'How do I add a new employee?',
              ans: 'From the left-side menu, click HRMS > Employees. On the Employees dashboard, click the Add Employee button (top-right corner). A registration form will open. Fill in the required details like Name, Email, Gender, Role, Department, Designation, Joining Date, Salary, etc. Click Submit to save. Once submitted, the employee will appear on the Employees Dashboard.'
            },
            {
              question: 'What details are required while adding a new employee?',
              ans: 'When registering a new employee, you need to provide:Basic Info: Name, Email, Gender, Mobile, National ID, Date of Birth.Work Info: Role, Designation, Department, Division, Work Type (On Site/Remote), Employee Type, Attendance Policy, Leave Policy. Other Info: Blood Group, Religion, Marital Status, Agreement Renewal Date, Salary Type, Monthly Salary, Password. Fields marked with * (red asterisk) are mandatory.'
            },
            {
              question: 'Where can I see the list of all employees?',
              ans: 'Go to HRMS > Employees from the left-side menu. Here, you’ll see a table with employee details like Name, Role, Designation, Status, Joining Date. You can also use filters (Employee, Role, Division, Department, Designation, Status) to search employees quickly.'
            },
            {
              question: 'How can I view an employee’s full profile?',
              ans: 'From the Employees dashboard, find the employee. On the right-hand side, click the View (eye icon). This will open the employee profile (basic details like Employee ID, Email, Contact Number, Division, Department, Role, Status). To see complete details, click Show Profile Details.'
            },
            {
              question: 'How do I update or edit an employee’s details?',
              ans: 'Go to HRMS > Employees. Find the employee in the list. On the right-hand side, click the View (eye icon). click Show Profile Details. After updating, click Save/Edit.'
            },
            {
              question: 'How do I update an employee’s status (Active/Inactive/Probationary)?',
              ans: 'Go to the employee’s profile via HRMS > Employees > View. Click Show Profile Details. Under Employment Status, update the status (e.g., Active, Inactive, Probationary, Resigned). Click Save/Edit to apply changes.'
            },
            {
              question: 'What is Machine Employee ID?',
              ans: 'The Machine Employee ID is a unique code linked to the biometric or attendance device. It ensures that an employee’s attendance data (check-in and check-out records) is correctly captured and synced with the HRMS.'
            },
            {
              question: 'How do I set an attendance policy for an employee?',
              ans: 'First, create an attendance policy in the Attendance section of the HRMS. While creating the policy, make sure it is mapped to the correct Department. During employee onboarding (Add Employee form), select the Department. Once a department is selected, the system will automatically display the associated Attendance Policy. Assign the policy to the employee before submitting the form.'
            },
            {
              question: 'How to create a new employee type (e.g., Full-time, Contract, Intern)?',
              ans: 'From the left-side menu, go to HRMS > Employee Types. On the Employee Types page, click the Create Type button (top-right corner). Enter the Name (e.g., Permanent, Probationary, Contractual, Intern, Part-Time, etc.) and an optional Description. Save the entry. The new Employee Type will now appear in the list and can be assigned when adding or updating employees.'
            },
            {
              question: 'How to assign an employee type during employee creation?',
              ans: 'First, create the Employee Type in HRMS > Employee Types. Then, while filling out the Add Employee form, select the appropriate type (e.g., Permanent, Probationary, Intern) from the Employee Type field before submitting.'
            },
            {
              question: 'How do I assign or set a Division Head?',
              ans: 'Go to HRMS > Division, then click the Edit button for the division. In the edit form, you’ll find a Head field. Select the employee you want to assign as Division Head from the dropdown menu and click Submit to save.'
            },
            {
              question: 'How do I assign a Department under a Division?',
              ans: 'Go to HRMS > Department, then click the Edit button for the department. In the edit form, locate the Division field. Select the desired Division from the dropdown menu and click Submit to save.'
            },
            {
              question: 'How do I assign or set a Department Head?',
              ans: 'Go to HRMS > Department, then click the Edit button for the department. In the edit form, you’ll find a Head field. Select the employee you want to assign as Department Head from the dropdown menu and click Submit to save.'
            },
            {
              question: 'How do I create a new attendance policy?',
              ans: 'Go to HRMS → Attendance → Policy from the left menu. Click the “Create Policy” button on the top-right. Fill in the required fields such as Check-In, Check-Out, Work Hours, Delay Buffer, Overtime, etc. Once done, click Submit. The new policy will now appear in the Attendance Policy Dashboard.'
            },
            {
              question: 'What is a “Delay Buffer” in attendance policy?',
              ans: 'A Delay Buffer allows a grace period in minutes for employees who are late before they are marked as late.'
            },
            {
              question: 'What is the “Extreme Delay Buffer”?',
              ans: 'Choose how many minutes after buffer time an employee is considered extreme late.'
            },
            {
              question: 'What is the “Buffered Overtime”?',
              ans: 'Specify the number of minutes after the scheduled checkout time when overtime will begin to be calculated.'
            },
            {
              question: 'What is the “Minimum Over Time”?',
              ans: 'Set the minimum number of minutes that must be worked beyond checkout time to qualify as overtime.'
            },
            {
              question: 'What is an Attendance Policy Map?',
              ans: 'An Attendance Policy Map is used to link an existing attendance policy to a specific division, department, or employee. This ensures that the correct policy is applied for attendance tracking and compliance across your organization.'
            },
            {
              question: 'How do I access the Attendance Policy Map?',
              ans: 'Go to HRMS > Attendance > Policy Map. You will see a dashboard displaying all existing policy mappings along with their effective dates and divisions.'
            },
            {
              question: 'How do I create a new Attendance Policy Map?',
              ans: 'Navigate to Policy Map under the Attendance section. Click the Create button on the top right.A form will open where you can enter details of the mapping. After filling in the details, click Submit.'
            },
            {
              question: 'What information do I need to provide while creating a Policy Map?',
              ans: 'You need to fill in the following fields: Policy: Select the attendance policy you want to map. Division: Choose the division where this policy will apply. Department: Assign the policy to a specific department within the division. Employee: You can assign the policy directly to an individual employee. Effective Date: Select the date from which the policy should take effect.'
            },
            {
              question: 'Can I assign a policy to a whole division or department?',
              ans: 'Yes. If you select a Division only, the policy will apply to the entire division. If you select both a Division and Department, the policy will be applied specifically to that department under the division.'
            },
            {
              question: 'Can I assign a policy to an individual employee?',
              ans: 'Yes. While creating a policy map, select the Employee field after choosing the division and department. This allows you to assign attendance rules directly to a specific employee.'
            },
            {
              question: 'Where can I view or edit existing policy maps?',
              ans: 'On the Policy Map Dashboard, you’ll see a list of all existing mappings. Each mapping has edit and delete icons under the Action column so you can update or remove them if needed.'
            },
            {
              question: 'What is Attendance Reconciliation in TaskFino?',
              ans: 'Attendance Reconciliation allows employees or admins to correct attendance records if there are missing entries, wrong check-ins/outs, or other discrepancies. It ensures accurate records for payroll and compliance.'
            },
            {
              question: 'How do I apply for Attendance Reconciliation for an employee?',
              ans: 'Navigate to Reconciliation under Attendance. Click the Apply button on the top right. A form will appear where you can select the date, time, reason etc. Submit the request to update the attendance record.'
            },
            {
              question: 'Who can apply for attendance reconciliation?',
              ans: 'Both employees and HR/admins can apply. Employees can submit requests for their own attendance, while HR or managers can submit on behalf of employees if required.'
            },
            {
              question: 'How can I check attendance details for employees?',
              ans: 'Go to HRMS > Attendance > Attendance. Use filters to select Employee, Division, Department, Employee Type, and Date. The system will display attendance status with details.'
            },
            {
              question: 'How can I generate attendance reports for employees?',
              ans: 'Go to HRMS > Attendance > Report.'
            },
            {
              question: 'How can I configure Web Attendance using IP authorization?',
              ans: 'Go to HRMS > Attendance > Web Attendance. Click Assign. In the pop-up form: Select Work Type. Select Division. Select Department. Select Employee. Set IP Authorize (Yes/No). Enter the IP Address. Click Submit to save.'
            },
            {
              question: 'What is Visit Attendance?',
              ans: 'Visit Attendance is a feature in TaskFino that allows employees to record attendance when they are working outside the office, such as during client meetings, training, or other official tasks.'
            },
            {
              question: 'When should I apply for Visit Attendance?',
              ans: 'You should apply whenever you have an official duty outside the office premises that requires tracking of your check-in and check-out times.'
            },
            {
              question: 'How do I apply for Visit Attendance?',
              ans: 'Go to Attendance → Visit Attendance from the left menu. Click Apply For Employee. Click Submit.'
            },

            {
              question: 'What types of leaves are available in TaskFino?',
              ans: 'TaskFino supports multiple leave categories such as Casual Leave, Sick Leave, Earned Leave, Maternity/Paternity Leave, and other company-specific leave types. The available categories depend on your organization’s policy.'
            },
            {
              question: 'How do I apply for leave?',
              ans: 'Navigate to Leave → Apply Leave, select the leave type, date range, and reason, then submit. Your manager will receive a notification for approval.'
            },
            {
              question: 'Can I apply for a half-day leave?',
              ans: 'Yes. While applying, select the Half-Day option and choose whether it’s for the first or second half of the day.'
            },
            {
              question: 'Can I apply for leave in advance?',
              ans: 'Yes. TaskFino allows you to apply for future dates, subject to your company’s leave policy.'
            },
            {
              question: 'How many days in advance should I apply for leave?',
              ans: 'This depends on your company’s policy. Casual leaves may be applied on short notice, while annual or vacation leaves often require prior approval.'
            },
            {
              question: 'Can I apply for leave for a past date?',
              ans: 'No. Employees cannot apply for leave on past dates. Only management or HR with admin access can submit leave for past dates on behalf of employees.'
            },
            {
              question: 'How do I track the status of my leave application?',
              ans: 'Go to Leave → Apply Leave to see whether your leave is Pending, Approved, or Rejected.'
            },
            {
              question: 'How can I check my leave balance?',
              ans: 'Navigate to Leave → Leave Balance to view your remaining days for each leave type.'
            },
            {
              question: 'Can I cancel or modify a leave request after submission?',
              ans: 'You cannot cancel a leave request on your own once submitted; only management or authorized approvers can do so. If the request is still pending, you may edit it. Once approved, contact your manager or HR for any changes.'
            },
            {
              question: 'Can someone else apply for leave on my behalf?',
              ans: 'Yes. Depending on the company’s configuration, managers or HR personnel may submit leave requests on behalf of employees.'
            },
            {
              question: 'Who approves my leave request?',
              ans: 'Typically, your reporting manager or HR approves leave applications. You will receive a system notification once a decision is made.'
            },
            {
              question: 'Can I view my past leave history?',
              ans: 'Yes. Under Apply Leave, you can view a complete history of your previous leave applications and their status.'
            },
            {
              question: 'What happens if I do not have sufficient leave balance?',
              ans: 'If your leave balance is insufficient, managers or HR may allocate additional leaves. They can also create a new leave category (e.g., Extra Leave) and assign it as per company policy.'
            },
            {
              question: 'Why am I unable to apply for leave?',
              ans: 'Possible reasons include:  Insufficient leave balance in the selected category. The leave window (advance or retroactive period) is restricted by company policy. Applying for two half-day leaves under different categories on the same day. Attempting to apply for another half-day leave on the same day before the previous half-day leave is approved.'
            },
            {
              question: 'What should I do if my leave balance is incorrect?',
              ans: 'If you notice discrepancies in your leave balance, contact your HR, Admin, or authorized personnel for correction.'
            },
            {
              question: 'Who should I contact if I face issues in the Leave module?',
              ans: 'Please contact your HR, Admin, or raise a support ticket within TaskFino.'
            },

            {
              question: 'How do I create a leave category?',
              ans: 'Go to Leave Types → Create Leave. A new window will open where you can select the leave type (Core or Additional), provide a title, set allowances, and configure any restrictions.'
            },
            {
              question: 'How do I assign leave to an employee?',
              ans: 'When a new employee is onboarded, the leave assignment option is available in the Employee Section while adding their details. HR, managers, or authorized personnel can assign leave to the employee on their joining date.'
            },
            {
              question: 'Can I add or modify leave after it has been assigned?',
              ans: 'Yes. Even after the initial leave assignment, HR, managers, or authorized personnel can add, change, or modify leave types at any time.'
            },
            {
              question: 'How can I change or modify the leave category for an employee after assignment?',
              ans: 'Navigate to HRMS → Employee Section, filter by the employee’s name, and click Edit. A window will open where you can change, add, or update the employee’s leave category.'
            },
            {
              question: 'Can I rename a leave category after it has been created?',
              ans: 'Yes. To rename a leave category, go to Leave Types, click the Edit option for the category you wish to change, enter the new name, and click Update.'
            }
          ]
        },
        asset: {
          icon: 'BoxIcon',
          title: 'Asset Management',
          subtitle: 'Asset tracking and management-related questions.',
          qandA: [
            {
              question: 'What is the Asset feature in TaskFino?',
              ans: 'The Asset feature allows the company to keep track of office assets like laptops, CPUs, RAM, headphones, and other equipment.'
            },
            {
              question: 'Why do we need to create a Category?',
              ans: 'Before adding assets, you need to create a Category so that all assets can be grouped properly (e.g., Laptop, Monitor, CPU, etc.).'
            },
            {
              question: 'How do I create a Category in Asset Management?',
              ans: 'Go to Assets in the TaskFino menu. Click the Create button. A Create Type popup will appear. Fill in the details. Click Submit to save.'
            },
            {
              question: 'What does “Type” mean in Asset Creation?',
              ans: 'Type defines the kind of asset (Laptop, RAM, CPU, Headphone, etc.) that falls under the selected category.'
            },
            {
              question: 'What should I enter in “Specification”?',
              ans: 'Specification means the technical or descriptive details of the asset.'
            },
            {
              question: 'What is the Asset feature?',
              ans: 'The Asset feature helps you keep track of all office assets, including purchase cost, warranty, assigned user, and status. It ensures assets are well-managed and easily accessible.'
            },
            {
              question: 'How do I add a new asset?',
              ans: 'Go to Asset → Asset from the left menu. Click on the Create button. A popup form will open where you need to fill in the asset details (Title, Asset Type, Category, Serial Number, Purchase Date, Cost, Warranty, etc.). Upload an asset image and click Submit.'
            },
            {
              question: 'What does “Title” mean in asset creation?',
              ans: 'The Title is the name of the asset. For example: Laptop Dell XPS 13, Office Chair, Employee ID Card.'
            },
            {
              question: 'What is Asset Type?',
              ans: 'Asset Type specifies whether the asset is a Primary Asset (essential/major) or an Additional Asset (supporting/secondary).'
            },
            {
              question: 'What is the difference between Manufacturer Serial Number and Company Serial Number?',
              ans: 'Manufacturer Serial Number: The unique number given by the manufacturer. Company Serial Number: A custom internal serial number assigned by your company for tracking.'
            },
            {
              question: 'Why do I need to enter Purchase Cost and Currency?',
              ans: 'This helps you track the financial value of assets in your organization’s preferred currency. It also helps in depreciation or budgeting.'
            },
            {
              question: 'Can I upload purchase receipts for assets?',
              ans: 'Yes. You can upload scanned receipts or documents as proof of purchase when creating or editing an asset.'
            },
            {
              question: 'What does Warranty information mean?',
              ans: 'You can add warranty details such as warranty type, duration, and expiry. TaskFino will show how many days are left in the warranty period.'
            },
            {
              question: 'Can I edit or delete an asset after creation?',
              ans: 'Yes. From the Asset list, click on the action menu (three dots) beside the asset and choose edit or delete.'
            },
            {
              question: 'How do I view details of an asset after adding it?',
              ans: 'Go to the Asset list and click on the asset you want to view. This will open the Asset Details page, where you can see complete information including title, serial ID, status, cost, and warranty.'
            },
            {
              question: 'How do I assign an asset to an employee?',
              ans: 'On the Asset Details page, click the Assign To User button. Select the employee from the dropdown and confirm. The assignment will be recorded in the asset’s history.'
            },
            {
              question: 'What is an Additional Asset?',
              ans: 'An Additional Asset is an extra part or accessory linked to a primary asset.'
            },
            {
              question: 'What is the “My Asset” section?',
              ans: 'The My Asset section shows a list of all assets currently assigned to you. It helps employees track and manage the assets they are responsible for.'
            }
          ]
        },
        payroll: {
          icon: 'CalendarIcon',
          title: 'Payroll Management',
          subtitle: 'Salary, disbursement, loan, and accounting-related questions.',
          qandA: [
            {
              question: 'Can I create different salary structures for employees?',
              ans: 'Yes. You can define and manage salary structures based on roles, departments, or grades. Each structure can include basic pay, allowances, deductions, and bonuses.'
            },
            {
              question: 'Does the system calculate salaries automatically?',
              ans: 'Yes. Monthly salaries are automatically calculated based on attendance, leaves, overtime, and other variables—minimizing manual errors.'
            },
            {
              question: 'Can the software handle performance-based bonuses and commissions?',
              ans: 'Absolutely. You can add performance-linked bonuses, sales commissions, and other incentives while also managing deductions such as loans, taxes, or penalties.'
            },
            {
              question: 'How does the system ensure tax compliance?',
              ans: 'The software allows you to configure tax rules and statutory deductions according to local labor laws and regulations, ensuring accurate computation and compliance.'
            },
            {
              question: 'Will employees get detailed payslips?',
              ans: 'Yes. The system generates downloadable and printable payslips with a complete breakdown of earnings, deductions, and net pay.'
            },
            {
              question: 'What details are included in each payslip?',
              ans: 'Each payslip contains:  Breakdown of earnings – Basic salary, allowances, bonuses, and commissions.  Deductions – Taxes, provident fund contributions, fines, late fines, and insurance premiums.  Net Pay – The final salary amount to be disbursed.  Payment Details – Date of payment, transaction reference, and payment method.'
            },
            {
              question: 'Can I track salary payments and transactions?',
              ans: 'Yes. You can monitor disbursed and pending salaries, payment methods, and transaction references—helping maintain accurate audit and financial records.'
            },
            {
              question: 'Does the module provide payroll reports?',
              ans: 'Yes. You can generate detailed reports such as salary summaries, department-wise payroll, tax deductions, and monthly disbursement logs for better financial insights.'
            },
            {
              question: 'How does the system handle salary disbursement?',
              ans: 'You can manage multiple disbursement methods, including direct bank transfers, and track all transactions to maintain accurate financial records.'
            },
            {
              question: 'How does it save time for organizations?',
              ans: 'By automating payroll processes, reducing manual work, and centralizing policies, disbursements, and reporting, the system helps HR and finance teams focus on more strategic tasks.'
            },
            {
              question: 'How does the system handle hourly or part-time employees?',
              ans: 'With the Hourly Work Option, the system calculates pay based on the number of logged hours, ideal for part-time or contractual workers.'
            },
            {
              question: 'Can project commissions be included in payroll?',
              ans: 'Yes. You can add Project Commissions for employees involved in sales or business development, directly linking incentives to project success.'
            },
            {
              question: 'What allowances and benefits can be included?',
              ans: 'You can configure allowances such as Meal Allowances, Festival Bonuses, Insurance coverage, and Provident Fund contributions (both employer and employee).'
            },
            {
              question: 'How does the system manage overtime and leave deductions?',
              ans: 'The system automatically calculates Overtime based on company policies and applies Extra Leave deductions for unpaid leave or compensations for unused leave.'
            },
            {
              question: 'Can fines and penalties be deducted through payroll?',
              ans: 'Yes. You can apply Fines for policy violations and Late Fines for attendance-related issues, with full transparency.'
            },

            // Disbursement Template
            {
              question: 'What is the Disbursement Template in TaskFino?',
              ans: 'The Disbursement Template allows administrators to streamline and automate salary payments by creating pre-defined templates for different departments, branches, or payment structures.'
            },
            {
              question: 'Can I choose different payment methods for employees?',
              ans: 'Yes. You can select payment methods such as bank transfer, cash, or digital wallets for each group of employees based on their preferences or company policies.'
            },
            {
              question: 'How can I schedule salary disbursements?',
              ans: 'The system supports flexible scheduling options, including monthly, bi-weekly, or custom cycles, making payroll planning smooth and predictable.'
            },
            {
              question: 'Does this help reduce errors in salary processing?',
              ans: 'Absolutely. By using templates, payroll officers can maintain a consistent and error-free disbursement workflow, even for large teams.'
            },
            {
              question: 'Can I process salaries for many employees at once?',
              ans: 'Yes. With pre-configured templates, payroll officers can process salaries for hundreds of employees with just a few clicks, saving significant time and effort.'
            },

            // Loan Management
            {
              question: 'Can employees apply for loans directly in the system?',
              ans: 'Yes. Employees can submit loan requests from their dashboard by entering the amount, reason, and preferred repayment terms.'
            },
            {
              question: 'Who reviews and approves loan applications?',
              ans: 'Admins or authorized personnel can review, approve, or reject requests with remarks, ensuring transparency and control.'
            },
            {
              question: 'How are loan repayments managed?',
              ans: 'Custom EMI (Equated Monthly Installment) plans can be configured, and installments are automatically deducted from salaries during payroll processing.'
            },
            {
              question: 'Does the system support interest-free and interest-bearing loans?',
              ans: 'Yes. You can set flat or percentage-based interest rates and define whether the loan should be interest-free or interest-bearing.'
            },
            {
              question: 'Can I track the status of an employee’s loan?',
              ans: 'Yes. The system maintains complete records, including approved amount, EMI history, remaining balance, and payment dates.'
            },
            {
              question: 'Does the software provide loan-related reports?',
              ans: 'Yes. You can generate reports on total loans issued, outstanding balances, and department-wise loan disbursements for better financial insights.'
            },
            {
              question: 'Can supporting documents be attached during application?',
              ans: 'Yes. Employees can attach necessary documents for verification, if required, to support their loan request.'
            },
            {
              question: 'How are approved loans disbursed in TaskFino?',
              ans: 'Once a loan is approved, HR or finance teams can disburse the loan directly through the system, making the process seamless and efficient.'
            },
            {
              question: 'Is the loan linked to the employee profile?',
              ans: 'Yes. Disbursed loans are linked to the employee’s profile for transparent tracking of balances, repayments, and EMIs.'
            },
            {
              question: 'Does the system handle EMI deductions automatically?',
              ans: 'Absolutely. Disbursed loans are reflected in payroll, and EMIs are automatically deducted from upcoming salary cycles, ensuring accuracy and timely repayment.'
            },
            {
              question: 'What details are included in the amortization table?',
              ans: 'It displays EMI amounts, due dates, interest, principal split, and remaining balance after each installment, giving full visibility of the loan status.'
            },
            {
              question: 'Does the table update automatically?',
              ans: 'Yes. The schedule updates in real time as payments are made or adjustments occur, ensuring accuracy.'
            },
            {
              question: 'Who can access the amortization table?',
              ans: 'HR, finance teams, and employees can all access it to monitor outstanding loans and repayment progress.'
            },
            {
              question: 'Can I generate loan statements for audits?',
              ans: 'Yes. The system provides downloadable loan statements for compliance, reporting, and audit purposes.'
            },

            // Accounting
            {
              question: 'Can I manage project budgets within the system?',
              ans: 'Yes. You can create, review, and approve or reject project budgets before execution to maintain financial control.'
            },
            {
              question: 'Does the software link payments with project milestones?',
              ans: 'Yes. You can align financial goals and payments with project milestones to ensure proper tracking of project progress and funding.'
            },
            {
              question: 'Can I create and manage invoices?',
              ans: 'Absolutely. The system allows you to create, send, and manage professional invoices while tracking paid, unpaid, and overdue statuses.'
            },
            {
              question: 'How are expenses recorded and tracked?',
              ans: 'You can record and categorize all company or project-related expenses, making it easy to monitor and analyze spending.'
            },
            {
              question: 'Does the module support multiple types of accounts?',
              ans: 'Yes. You can manage different accounts such as bank, cash, and digital wallets, and monitor balances and transactions in real time.'
            },
            {
              question: 'Can I handle deposits and internal fund transfers?',
              ans: 'Yes. The system lets you record deposits, manage internal fund transfers, and keep accurate financial records.'
            },
            {
              question: 'Is there support for compliance and auditing?',
              ans: 'Yes. All entries are recorded in the general ledger, ensuring accuracy and compliance while making audits simpler and more transparent.'
            },
            {
              question: 'Can I view upcoming project milestones and payments?',
              ans: 'Yes. The system displays all upcoming due milestones within the next 30 days, including project title, payment amount, and payment type.'
            },
            {
              question: 'Does the module track overdue milestones?',
              ans: 'Yes. You can easily view overdue milestones with their deadlines, amounts, and payment types for quick follow-up.'
            },
            {
              question: 'How does milestone tracking help in project management?',
              ans: 'It ensures timely payment collection, better cash flow visibility, and keeps projects financially on track.'
            },
            {
              question: 'Can I filter or sort milestone data?',
              ans: 'Yes. You can filter milestones by project, due date, or payment type for easier management.'
            },
            {
              question: 'What does the Project Status Summary show?',
              ans: 'The Project Status Summary gives you a clear overview of all projects categorized by their progress status.'
            },
            {
              question: 'What categories are available in the summary?',
              ans: 'Projects are grouped into the following categories: Total, Approved, Pending, Not Started, Ongoing, and Finished.'
            },
            {
              question: 'How does this feature help in project management?',
              ans: 'It provides quick visibility of project progress, helping managers track workload, monitor deadlines, and make informed decisions.'
            },
            {
              question: 'Can I view detailed information for each category?',
              ans: 'Yes. You can click on any category to see the detailed list of projects under that status.'
            },

            // Financial Summary
            {
              question: 'What does the Due Invoice Summary show?',
              ans: 'The Due Invoice Summary displays all upcoming invoices within the next 30 days, including invoice details, due amounts, and deadlines.'
            },
            {
              question: 'Can I track upcoming salary and payments?',
              ans: 'Yes. The Account Payslip Summary provides details of upcoming employee salaries and other scheduled payments.'
            },
            {
              question: 'Does the system give an overview of income and expenses?',
              ans: 'Yes. The Income & Expense Summary shows total income and expenses, along with a visual graph comparing the two.'
            },
            {
              question: 'How does the Financial Summary help businesses?',
              ans: 'It provides a quick snapshot of due invoices, upcoming payments, and overall cash flow, making it easier to plan finances and ensure timely disbursements.'
            },
            {
              question: 'Does the system notify or automate invoices and payment requests?',
              ans: 'Yes. When a milestone is completed, the system automatically sends notifications and can trigger invoices or payment requests, ensuring timely and accurate financial processing.'
            }
          ]
        },

        crm: {
          icon: 'BarChart2Icon',
          title: 'CRM System',
          subtitle: 'Lead management and financial estimation-related questions.',
          qandA: [
            {
              question: 'How do I add a new lead in CRM?',
              ans: 'Step 1: From the left-side menu, click on CRM → My Leads. Step 2: On the top right corner, click the “Add Lead” button. Step 3: Fill in the lead details in the form (Lead Title, Client Information, Key Contact Person, Source, Category, Department, etc.). Step 4: Click Submit.  Your lead will now appear in the My Leads Dashboard.'
            },
            {
              question: 'Where can I see all my leads?',
              ans: 'Go to CRM → My Leads. Here, you’ll see a table of all leads with details like company name, contact person, assigned employee, key account manager, status, and next contact date.'
            },
            {
              question: 'How do I edit or update a lead?',
              ans: 'On the lead card, go to the right-hand side and click the three dots (⋮). You will see two options: Edit – to update or change lead details (e.g., client info, status, assigned employee). Show – to view the lead’s full details and activity updates.'
            },
            {
              question: 'What happens when I click “Show” on a lead?',
              ans: 'Clicking Show opens the Lead Dashboard, where you can: View all client details. Track communication history. Update activity logs. Monitor the lead’s current progress (Proposal Sent, Meeting Scheduled, Follow-Up, etc.).'
            },
            {
              question: 'How do I update an activity log for a lead?',
              ans: 'Step 1: Open the lead (by clicking Show or clicking the lead card). Step 2: Go to the Activity Log section. Step 3: Click Add Activity. Step 4: A new form will pop up where you can add details such as follow-up date, notes, call updates, meeting outcomes, or proposal status. Step 5: Submit, and the activity will be recorded in the log.'
            },
            {
              question: 'What kind of statuses can I assign to a lead?',
              ans: 'Typical lead statuses include: Lead Initial Contact Meeting Proposal Sent Follow Up Meeting Converted Lost You can select the status while adding or editing a lead.'
            },
            {
              question: 'How do I assign a lead to an employee?',
              ans: 'While adding or editing a lead, go to the Lead Assignee Information section. Select the Key Account Manager / Assigned Employee from the dropdown list. The lead will now be under that employee’s responsibility.'
            },
            {
              question: 'Can I upload documents or business cards for a lead?',
              ans: 'Yes. While adding or editing a lead, you can upload files: Business Card (Front) Business Card (Back) Just drag and drop or use the “Browse” button to upload.'
            },
            {
              question: 'How can I search or filter leads?',
              ans: 'In the My Leads Dashboard, use the search bar or filters (by status, department, category, or assigned employee). This helps you quickly find the lead you are looking for.'
            },
            {
              question: 'What is the difference between “Edit” and “Activity Update”?',
              ans: 'Edit → Use this to correct or update static lead information (company name, email, phone, assigned employee, etc.).  Activity Update (Activity Log) → Use this to record progress or interactions (meetings, follow-ups, calls, proposals).'
            },
            {
              question: 'What happens when a client lead is converted?',
              ans: 'A: Once a lead is successfully converted, the system shows a confirmation message: “This lead has been converted successfully & locked!”. At this stage, you will also see the Financial Estimation button on the Lead Details page. This means you can now prepare and send the financial estimation for the project.'
            },
            {
              question: 'Where can I find the Financial Estimation option?',
              ans: 'A: After a lead is marked as Converted/Won, go to the Lead Details page. You will see a green button labeled Financial Estimation. Click on it to open the financial estimation form.'
            },
            {
              question: 'What is the purpose of the Financial Estimation form?',
              ans: 'The Financial Estimation form allows you to enter all the project’s financial details (such as project type, payment method, duration, taxes, and milestones). Once filled, the estimation is sent to the Finance Department for review and approval.'
            },
            {
              question: 'What information do I need to fill in the Financial Estimation form?',
              ans: 'You will need to provide the following: Project Type – Select the relevant project type (e.g., Monthly, Fixed).  Currency – Choose the currency in which payment will be made.  Final Amount – Enter the estimated total amount before taxes.  VAT & Tax – Add applicable VAT and Tax amounts.  Time Duration (Months) – Mention how long the project will last.  Payment Type – Select how the client will pay (e.g., Full, Installments, Milestone-based).  Number of Milestones – If milestone-based, enter how many milestones are planned.  Proposal Document – Upload a proposal file (if available).  Remarks – Add any important notes or conditions.'
            },
            {
              question: 'How is the Grand Total calculated?',
              ans: 'The Grand Total is automatically calculated as: Final Amount + VAT + TAX You just need to enter the amounts correctly; the system will add them up.'
            },
            {
              question: 'Can I upload a proposal or supporting documents?',
              ans: 'There is a section to upload a proposal document (e.g., PDF, Word, Excel). Simply click Browse or drag and drop your file.'
            },
            {
              question: 'What happens after I submit the estimation?',
              ans: 'Once you click Submit, the financial estimation is locked and sent to the Finance Department. They will review the details, verify the numbers, and approve or request modifications.'
            },
            {
              question: 'Can I edit the estimation after submission?',
              ans: 'After submission, the estimation is usually locked for editing to maintain accuracy. If changes are needed, you must request the Finance Department or your manager to unlock or create a revised estimation.'
            },
            {
              question: 'Who can view the financial estimation?',
              ans: 'The estimation is visible to: The user who created it (you).  The Finance Department for approval.  The Key Contact Manager or higher authority (depending on company settings).'
            },
            {
              question: 'What should I do if I don’t know the VAT or Tax amounts?',
              ans: 'If you’re unsure about VAT or Tax, consult with your Finance Department before submitting. Entering incorrect values may delay approval.'
            },
            {
              question: 'What if the client requests changes in estimation after submission?',
              ans: 'If a client negotiates after submission, you may need to: Request the Finance Department to revise the estimation. Create a new estimation and mark the previous one as Revised.'
            },
            {
              question: 'Why is the Financial Estimation important?',
              ans: 'The estimation ensures: Transparency of project costs.  Proper documentation for Finance & Management.  Smooth approval and billing process.'
            },
            {
              question: 'What should I do if there is no VAT or TAX for a lead/client?',
              ans: 'If the client does not have VAT or TAX applicable: Simply enter 0 in the VAT and TAX fields. The system will accept it, and you can continue without leaving it blank.'
            }
          ]
        },
        // Tasks & Projects
        tasks: {
          icon: 'CheckSquareIcon',
          title: 'Task & Project Management',
          subtitle: 'Workflow, projects, and productivity.',
          qandA: [
            {
              question: 'How can I visualize my team\'s project workflow?',
              ans: 'You can use Task Boards, which function like Kanban boards. This allows you to create columns for different stages (e.g., "To-Do," "In Progress," "Completed") and move tasks between them for a clear, visual overview of progress.'
            },
            {
              question: 'Can I break a large task into smaller subtasks?',
              ans: 'Yes, the Subtask feature lets you break down complex tasks into smaller, manageable steps. You can assign these subtasks to different team members and track their progress individually.'
            },
            {
              question: 'Is there a way to see all tasks across all projects in one place?',
              ans: 'Yes, the Task Global View provides a centralized dashboard where you can see and filter all tasks across every project in the organization, which is ideal for high-level management.'
            }
          ]
        },
        // Accounting
        accounting: {
          icon: 'BriefcaseIcon',
          title: 'Accounting & Finance',
          subtitle: 'Invoicing, expenses, and financial tracking.',
          qandA: [
            {
              question: 'How does the Accounting module handle project-based billing?',
              ans: 'You can create Projects, define specific payment Milestones, and generate professional Invoices linked directly to those milestones. This allows you to easily track payments against project progress.'
            },
            {
              question: 'Can I track project-related expenses?',
              ans: 'Yes, the Expense feature allows you to record and categorize all company spending. You can link expenses to specific projects to monitor their profitability and attach digital receipts for verification.'
            },
            {
              question: 'Is it possible to manage multiple bank accounts?',
              ans: 'Absolutely. You can define different Account Types (e.g., Bank, Cash) and manage them all in one place. The system allows you to record deposits, handle fund transfers between accounts, and view a complete transaction history.'
            }
          ]
        },
      },
      faqData: {},
      bannerImage,
      xdeskUser:{
        name: "TaskFino",
        email: "support@taskfino.com",
      },
      isLoading: false,
    }
  },
  watch: {
    faqSearchQuery: {
      immediate: true,
      handler() {
        this.filterData()
      },
    },
  },
  computed: {
    ...mapGetters({
      user: "userModule/getUser",
      permissions: "userModule/getPermissions",
    }),
  },
  methods: {
    filterData() {
      // Initialize the data and search term
      const searchTerm = this.faqSearchQuery.toLowerCase(); // Make it case-insensitive
      const filteredData = {}; // Initialize an empty object for filtered results

      // Loop through each category in faqData
      for (const [key, category] of Object.entries(this.data)) {
        // Filter the qandA based on the search term
        const filteredQandA = category.qandA.filter(faq => {
          // Check if the question or ans includes the search term
          return (
              faq.question.toLowerCase().includes(searchTerm) ||
              faq.ans.toLowerCase().includes(searchTerm)
          );
        });

        // Only add the category if it has filtered Q&As
        if (filteredQandA.length > 0) {
          filteredData[key] = {
            ...category, // Preserve the original category data
            qandA: filteredQandA, // Update with filtered Q&As
          };
        }
      }

      // Update the faqData with filtered results (if you want to update the displayed data)
      this.faqData = filteredData;

      return filteredData; // Return the filtered results
    },
    setLoading(value) {
      this.isLoading = value;
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>

<style scoped>
.youtube-btn {
  border-radius: 50%;
  padding: 0;
  /* color: red; YouTube red */
}
.faq-contact-card {
  border-radius: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

.icon-circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.youtube-gradient {
  background: linear-gradient(135deg, #ff0000, #cc0000);
}

.doc-gradient {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
}

</style>
